import React, { useState, useEffect, useReducer } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  Dropdown,
  Progress,
  Alert,
} from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  UnorderedListOutlined,
  UserOutlined,
  PieChartOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import { TableCustom } from "../../../components/table";
import { getAllActiveFormsApi } from "../../../api/formsColaboradoresForms";
import { reducerRegister } from "../../../helpers/reducers";
import { searchCollaboratorsApi } from "../../../api/colaboradores";
import {
  createCampaignApi,
  deleteCampaignApi,
  getAllCampaignsApi,
  getCampaignByIdApi,
  updateCampaignApi,
} from "../../../api/formsColaboradoresCampaigns";
const { Text } = Typography;

const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Finalizado" },
  { value: 2, label: "Liberado" },
];

const options_tipo = [
  { value: 1, label: "Colaborador" },
  { value: 2, label: "Outro" },
];

const array_status = {
  ["0"]: "Inativo",
  ["1"]: "Finalizado",
  ["2"]: "Liberado",
};

const rules = {
  descricao: [{ required: true, message: "Digite a descrição!" }],
  id_cad_formularios: [{ required: true, message: "Selecione o formulário!" }],
  status: [{ required: true, message: "Selecione o status!" }],
  tipo_parametro: [{ required: true, message: "Selecione o tipo!" }],
  descricao_parametro: [{ required: true, message: "Informe a descrição do parametro!" }],
  id_colaborador_parametro: [{ required: true, message: "Selecione o colaborador!" }],
};

const getPercent = (value, total) => {
  if (total === 0 || value === 0) {
    return 0;
  }

  return (Number(value) / Number(total)) * 100;
};

export const FormulariosColaboradoresCampanhas = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const tipo_parametro = Form.useWatch("tipo_parametro", form);
  const status = Form.useWatch("status", form);
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [forms, setForms] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [idAlt, setIdAlt] = useState(0);

  useEffect(() => {
    getAllCampaigns();
    getAllActiveForms();
    searchCollaborators();
  }, []);

  const getAllActiveForms = async () => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllActiveFormsApi();
      if (statusCode === 200) {
        let array_forms = [];
        for (const el of response.data) {
          array_forms.push({ value: el.id, label: el.descricao });
        }
        setForms(array_forms);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const searchCollaborators = async (search = "") => {
    try {
      const { response, statusCode } = await searchCollaboratorsApi(search);
      if (statusCode === 200) {
        let array_options = [];
        for (const el of response.data) {
          array_options.push({ value: el.id, label: `${el.matricula} - ${el.nome}` });
        }
        setCollaborators(array_options);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    }
  };

  const getAllCampaigns = async () => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllCampaignsApi();
      if (statusCode === 200) {
        dispatch({ type: "LOAD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const createCampaigns = async (data) => {
    setLoading(true);
    try {
      const { statusCode, response } = await createCampaignApi(data);
      if (statusCode === 200) {
        message.success("Registro cadastrado com sucesso!");
        setShowModal(false);
        resetForm();
        if (response?.data) dispatch({ type: "ADD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const updateCampaigns = async (data) => {
    setLoading(true);
    try {
      const { statusCode, response } = await updateCampaignApi(data);
      if (statusCode === 200) {
        message.success("Registro alterado com sucesso!");
        setShowModal(false);
        resetForm();
        if (response?.data) dispatch({ type: "UPDATE", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const getCampaignById = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getCampaignByIdApi(id);
      if (statusCode === 200) {
        setShowModal(true);

        if (response?.data?.id_colaborador_parametro > 0) {
          setCollaborators([
            {
              label: `${response?.data?.matricula_colaborador} - ${response?.data?.colaborador}`,
              value: response?.data?.id_colaborador_parametro,
            },
          ]);
        }

        form.setFieldsValue({
          descricao: response?.data?.descricao,
          id_cad_formularios: response?.data?.id_cad_formularios,
          id_colaborador_parametro: response?.data?.id_colaborador_parametro,
          tipo_parametro: response?.data?.tipo_parametro,
          observacoes: response?.data?.observacoes,
          status: response?.data?.status,
          parecer_final: response?.data?.parecer_final,
        });
        setIdAlt(response.data.id);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const deleteCampaign = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await deleteCampaignApi(id);
      if (statusCode === 200) {
        message.success("Registro deletado com sucesso!");
        dispatch({ type: "DELETE", payload: { id: id } });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Formulário",
      dataIndex: "formulario",
    },
    {
      title: "Parâmetro Avaliado",
      dataIndex: "parametro",
      render: (_, e) => (e.tipo_parametro === 1 ? e.colaborador : e.descricao_parametro),
      renderText: (e) => (e.tipo_parametro === 1 ? e.colaborador : e.descricao_parametro),
    },
    {
      title: "T. Concluídos",
      dataIndex: "total_concluidos",
    },
    {
      dataIndex: "andamento",
      title: "Andamento",
      render: (_, e) => (
        <Progress
          format={(e) => e.toFixed(0) + "%"}
          strokeColor={"#60b565"}
          percent={getPercent(e.total_concluidos, e.total_formularios)}
          steps={5}
        />
      ),
      renderText: (e) => `${getPercent(e.total_concluidos, e.total_formularios)} %`,
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (_, e) => array_status[e.status],
      renderText: (e) => array_status[e.status],
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Colaboradores">
            <Button
              loading={loading}
              onClick={() => navigate(`/formularios-colaboradores/campanhas/colaboradores/${e.id}`)}
              icon={<UserOutlined />}
            />
          </Tooltip>
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  label: "Relatório Geral",
                  onClick: () => navigate(`/formularios-colaboradores/campanhas/relatorio/${e.id}`),
                },
                {
                  key: "2",
                  label: "Relatório Pontuação",
                  onClick: () => navigate(`/formularios-colaboradores/campanhas/relatorio-pontuacao/${e.id}`),
                },
              ],
            }}
            placement="bottom">
            <Button loading={loading} icon={<PieChartOutlined />} />
          </Dropdown>
          <Button loading={loading} onClick={() => getCampaignById(e.id)} icon={<EditOutlined />} />
          <Button
            danger
            loading={loading}
            icon={<DeleteOutlined />}
            onClick={() => {
              modal.confirm({
                title: "Deseja deletar este registro?",
                okText: "Sim",
                cancelText: "Cancelar",
                onOk() {
                  deleteCampaign(e.id);
                },
              });
            }}
          />
        </Space.Compact>
      ),
    },
  ];

  const onSubmit = (formData) => {
    if (idAlt > 0) {
      formData.id = idAlt;
      updateCampaigns(formData);
    } else {
      createCampaigns(formData);
    }
  };

  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Campanha
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="descricao" label="Descrição" rules={rules.descricao}>
              <Input size="large" disabled={loading || idAlt > 0} placeholder="Informe a descrição" />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="id_cad_formularios" label="Formulário" rules={rules.id_cad_formularios}>
              <Select
                size="large"
                placeholder="Selecione o formulário"
                disabled={loading || idAlt > 0}
                style={{ width: "100%" }}
                options={forms}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="tipo_parametro" label="Tipo Parâmetro" rules={rules.tipo_parametro}>
              <Select
                size="large"
                placeholder="Selecione o tipo"
                disabled={loading || idAlt > 0}
                style={{ width: "100%" }}
                options={options_tipo}
              />
            </Form.Item>
          </Col>

          {tipo_parametro === 2 && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="descricao_parametro" label="Descrição Parâmetro" rules={rules.descricao_parametro}>
                <Input size="large" disabled={loading || idAlt > 0} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>
          )}

          {tipo_parametro === 1 && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="id_colaborador_parametro" label="Colaborador" rules={rules.id_colaborador_parametro}>
                <Select
                  showSearch
                  size="large"
                  placeholder="Selecione o colaborador"
                  disabled={loading || idAlt > 0}
                  options={collaborators}
                  onSearch={(e) => searchCollaborators(e)}
                  filterOption={false}
                />
              </Form.Item>
            </Col>
          )}

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="status" label="Status" rules={rules.status}>
              <Select
                size="large"
                placeholder="Selecione o status"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_status}
              />
            </Form.Item>
          </Col>

          {status === 1 && tipo_parametro === 1 && (
            <Col className="gutter-row" span={24} style={{ marginBottom: 10 }}>
              <Alert
                showIcon
                message="Atenção! Este parecer será adicionado nos acompanhamentos do colaborador no sistema Gestão RH."
              />
            </Col>
          )}

          {status === 1 && (
            <Col className="gutter-row" span={24}>
              <Form.Item name="parecer_final" label="Parcer Final">
                <Input.TextArea
                  maxLength={1500}
                  showCount
                  size="large"
                  disabled={loading}
                  placeholder="Informe o parecer"
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={24} lg={22} xl={22} xxl={20} align="left">
          <div className="content-item">
            <HeaderPage title="Formulários Colaboradores" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Campanhas"
              subtitle="Cadastro de campanhas"
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                expandable={{
                  expandedRowRender: (item) => <span className="line-break">{item.parecer_final}</span>,
                }}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
